export var DiningOptionEnum;
(function (DiningOptionEnum) {
    DiningOptionEnum["TAKE_OUT"] = "TAKE_OUT";
    DiningOptionEnum["DINE_IN"] = "DINE_IN";
    DiningOptionEnum["CURBSIDE"] = "CURBSIDE";
    DiningOptionEnum["DELIVERY"] = "DELIVERY";
    DiningOptionEnum["TO_COUNTER"] = "TO_COUNTER";
    DiningOptionEnum["MULTI_LOCATION"] = "MULTI_LOCATION";
})(DiningOptionEnum || (DiningOptionEnum = {}));
//# sourceMappingURL=DiningOptionEnum.js.map